import { render, staticRenderFns } from "./OracleSyncOrderStatusFailure.vue?vue&type=template&id=474a993b&scoped=true"
import script from "./OracleSyncOrderStatusFailure.vue?vue&type=script&lang=js"
export * from "./OracleSyncOrderStatusFailure.vue?vue&type=script&lang=js"
import style0 from "./OracleSyncOrderStatusFailure.vue?vue&type=style&index=0&id=474a993b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474a993b",
  null
  
)

export default component.exports